/** TanStack Query keys. Workspace-scoped keys start with ['ws', workspaceId] so switching workspace never mixes caches. */
export const qk = {
  me: ['me'] as const,
  ws: (w: string | null) => ['ws', w] as const,
  overview: (w: string | null) => ['ws', w, 'overview'] as const,
  projects: (w: string | null, customerId?: string) => ['ws', w, 'projects', customerId ?? 'all'] as const,
  project: (w: string | null, id: string) => ['ws', w, 'project', id] as const,
  customers: (w: string | null) => ['ws', w, 'customers'] as const,
  customer: (w: string | null, id: string) => ['ws', w, 'customer', id] as const,
  kitTree: (w: string | null) => ['ws', w, 'kits'] as const,
  kit: (w: string | null, id: string) => ['ws', w, 'kit', id] as const,
  members: (w: string | null) => ['ws', w, 'members'] as const,
  invites: (w: string | null) => ['ws', w, 'invites'] as const,
  workspace: (w: string | null) => ['ws', w, 'workspace'] as const,
  devices: (w: string | null) => ['ws', w, 'devices'] as const,
  deviceFiles: (w: string | null, deviceId: string) => ['ws', w, 'device-files', deviceId] as const,
  sessions: (w: string | null, episodeId: string) => ['ws', w, 'sessions', episodeId] as const,
  session: (w: string | null, id: string) => ['ws', w, 'session', id] as const,
  transcript: (w: string | null, sessionId: string) => ['ws', w, 'transcript', sessionId] as const,
  drilldown: (w: string | null, episodeId: string) => ['ws', w, 'drilldown', episodeId] as const,
  domains: (w: string | null) => ['ws', w, 'domains'] as const,
  brandingSettings: (w: string | null) => ['ws', w, 'branding'] as const,
  emailSender: (w: string | null) => ['ws', w, 'email-sender'] as const,
  branding: ['branding'] as const,
  billing: (w: string | null) => ['ws', w, 'billing'] as const,
  billingInvoices: (w: string | null) => ['ws', w, 'billing', 'invoices'] as const,
  invitePreview: (token: string) => ['invite', token] as const,
  review: (token: string) => ['review', token] as const,
  approvals: (w: string | null, filter: string) => ['ws', w, 'approvals', filter] as const,
  approval: (w: string | null, editId: string) => ['ws', w, 'approval', editId] as const,
  tasks: (w: string | null, q: Record<string, unknown>) => ['ws', w, 'tasks', q] as const,
  task: (w: string | null, id: string) => ['ws', w, 'task', id] as const,
  taskSettings: (w: string | null) => ['ws', w, 'task-settings'] as const,
  taskAssignees: (w: string | null, projectId: string) => ['ws', w, 'task-assignees', projectId] as const,
  taskEmail: (w: string | null) => ['ws', w, 'task-email'] as const,
  activity: (w: string | null, q: Record<string, unknown>) => ['ws', w, 'activity', q] as const,
};
